import '../../index.css';
var styles = {
  "button": "bp_base_button_module_button--b3ccf",
  "icon": "bp_base_button_module_icon--b3ccf",
  "primary": "bp_base_button_module_primary--b3ccf",
  "secondary": "bp_base_button_module_secondary--b3ccf",
  "tertiary": "bp_base_button_module_tertiary--b3ccf",
  "outline": "bp_base_button_module_outline--b3ccf",
  "small": "bp_base_button_module_small--b3ccf",
  "isIconButton": "bp_base_button_module_isIconButton--b3ccf",
  "large": "bp_base_button_module_large--b3ccf",
  "hide": "bp_base_button_module_hide--b3ccf"
};
export { styles as default };